import * as React from "react";
import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import Button from "@mui/material/Button";
import s from "./WhoWeAre.module.css";

let opening =
  "Our extensive in-house capabilities allow us to offer a true one-stop-shop experience for our airline, OEM, MRO and military customers.";
let subtext =
  "Our level of control over the repair process lends us the uniquely independent opportunity to pass along direct savings to our customers without sacrificing quality or turn time, or having to manage a cumbersome supplier base.";
let paragraph3 =
  "As a certified repair station, we hold FAA, EASA, CAAC, UK CAA, ISO9001:2015, and AS9110C certifications.";
let paragraph4 =
  "With in-house engineering services available and an existing portfolio of over 2,200 FAA approved or authorized repairs, we have the ability to extend the value of nearly every part we service which considerably lowers the operating cost for our customers.";

function WhoWeAre() {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down("sm"));
  const isLg = useMediaQuery(theme.breakpoints.down("lg"));

  return (
    <div>
      <div
        id="WhoWeAre"
        className={s.whoWeAreHeader}
        style={{ backgroundColor: "#195A92", color: "white", padding: 40 }}
      >
        <Grid container spacing={{ xs: 1, sm: 2, md: 2 }}>
          <Grid item xs={12} sm={12} md={7}>
            <div
              id="Opening"
              style={{ padding: 20, fontSize: 22, textAlign: "left" }}
            >
              <h1 style={{ fontSize: isSm ? 32 : isLg ? 42 : 50, margin: 0 }}>
                OUR CAPABILITIES
              </h1>
              {opening} <br />
              <br />
              {subtext}
              <br />
              <br />
              <Button
                style={{
                  backgroundColor: "#d96227",
                }}
                variant="contained"
              >
                <a href="#SEARCH REPAIRS">SEARCH CAPABILITIES</a>
              </Button>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={5}>
            <Box
              component={"img"}
              src="https://aci-website.s3.us-east-2.amazonaws.com/Images/ContactUs.jpg"
              alt="CAPABILITIES"
              loading="lazy"
              width="100%"
              sx={{
                borderRadius: 3,
                boxShadow: "0 4px 8px 0 rgba(0,0,0,0.6);",
              }}
            ></Box>
          </Grid>
        </Grid>{" "}
      </div>

      <div
        id="WhoWeAre2"
        style={{ backgroundColor: "#777", color: "white", padding: 40 }}
      >
        <Grid container spacing={{ xs: 1, sm: 2, md: 2 }}>
          <Grid item xs={12} sm={12} md={5}>
            <Box
              component={"img"}
              src="https://aci-website.s3.us-east-2.amazonaws.com/Images/GrindShop.jpg"
              loading="lazy"
              alt="FAA Repair Station"
              width="100%"
              sx={{
                borderRadius: 3,
                boxShadow: "0 4px 8px 0 rgba(0,0,0,0.6);",
              }}
            ></Box>
          </Grid>

          <Grid item xs={12} sm={12} md={7}>
            <div
              id="Opening"
              style={{ padding: 20, fontSize: 22, textAlign: "left" }}
            >
              <h1 style={{ fontSize: isSm ? 32 : isLg ? 42 : 50, margin: 0 }}>
                CERTIFIED REPAIR STATION
              </h1>
              {paragraph3}
              <br />
              <br />
              {paragraph4} <br />
              <br />
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

export default WhoWeAre;
